var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"حساب های کل و معین"}},[_c('b-button',{attrs:{"variant":"success","href":"#/addTopic"}},[_vm._v("جدید")]),_c('v-treeview',{attrs:{"open-all":"","hoverable":"","items":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }